<template>
  <div 
    class="table-img">
    <el-image 
      v-if="data"
      :preview-src-list="[data]" 
      :src="data"/>
    <span 
      v-else 
      class="no-data">
      暂无图像
    </span>
  </div>
</template>

<script>
export default {
  props: {
    data: String
  }
}
</script>

<style lang="scss" scoped>
.table-img{
  display: flex;
  justify-content: center;
  .el-image{
    width: 100%;
    height: 100%;
    >>> img{
      object-fit: contain;
      max-height: 371px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TableCell/TableImg.vue